<template>
  <div>
    <Chart
      v-if="dataset.data.length>0"
      :data="dataset.data" :labels="dataset.labels" 
    />
    <div v-else class="d-flex flex-column align-center mt-8">
      <v-icon size="100px" color="yellow darken-2">
        mdi-emoticon-sad-outline
      </v-icon>
    </div> 
  </div>
</template>

<script>
  import Chart  from './chart';

  export default {
    name: 'DashboardProsChart',

    props: ['limit', 'days'],

    components: { Chart },

    // methods: {
    //   onDrill(index) { this.$emit('drill', this.dataset.ids[index])},
    //   onClear()  { this.$emit('clear') }
    // },

    watch: {
      days() {
        this.loadData()
      },
    },

    methods: {
      async loadData() {
        const result = await this.load({ limit: this.limit, days: this.days })

        if (result.ok) {
          const referralCount = result.data.data[0].reduce((a,i) => a + i, 0)
          this.$emit('referralCount', referralCount)
        }
      }
    },

    created() {
      this.loadData()
    }
  }
</script>
